<template>
  <div>

    <div v-if="action === 'create' || action === 'edit'" class="modal fade" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <template v-if="action === 'create'">
              <h4 class="modal-title">Create new Portfolio</h4>
              <small class="font-bold">A portfolio can contain several projects to better organize them.</small>
            </template>
            <template v-else>
              <h4 class="modal-title" v-if="portfolio">Edit Portfolio : {{portfolio.name}}</h4>
              <small class="font-bold">A portfolio can contain several projects to better organize them.</small>
            </template>
          </div>
          <form v-on:submit="createPortfolio" action="#" method="post">
            <div class="modal-body">
              <div class="form-group">
                <label class="control-label required" for="name">Name</label>
                <input v-model="name" type="text" placeholder=""
                       title="" value="" name="name" id="name"
                       class="form-control">
                <span v-if="errorName" class="help-block text-danger">{{this.errorName}}</span>
              </div>
              <div class="form-group">
                <label class="control-label" for="description">Description</label>
                <textarea v-model="description" title=""
                          placeholder="" name="description"
                          id="description" class="form-control" cols="4" rows="4" maxlength="255"></textarea>
                <span class="help-block m-b-none">Description can make 255 character</span>
                <span v-if="errorDescription" class="help-block text-danger">{{this.errorDescription}}</span>
              </div>

              <div style="text-align: right;margin-top: 10px">
                <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="onCancel">Cancel</button>
              <vue-ladda v-if="action === 'create'" type="submit" :loading="submitPortfolio.loading" class="btn btn-info" :data-style="submitPortfolio.dataStyle">Create new portfolio</vue-ladda>
              <vue-ladda v-if="action === 'edit'" type="submit" :loading="submitPortfolio.loading" class="btn btn-info" :data-style="submitPortfolio.dataStyle">Save changes</vue-ladda>

            </div>
          </form>

        </div>
      </div>

    </div>

    <div v-else-if="this.action === 'delete'" class="modal fade hmodal-danger" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Delete Portfolio</h4>
          </div>
          <div class="modal-body">
            <h3>Are you sure you want to delete this portfolio : {{portfolio.name}}?</h3>
            <div>
              <span>Deleting a portfolio is irreversible</span>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="onCancel">Cancel</button>
            <vue-ladda type="submit" :loading="submitPortfolio.loading" class="btn btn-danger" :data-style="submitPortfolio.dataStyle" v-on:click="deletePortfolio">Delete Portfolio</vue-ladda>
          </div>
        </div>
      </div>
    </div>
    <limit-plan ref="limitPlan" :on-hidden="() => $emit('input', null)"></limit-plan>
  </div>

</template>

<script>
import VueLadda from 'vue-ladda'
import LimitPlan from '../../components/LimitPlan'

export default {
  components: {
    VueLadda,
    LimitPlan
  },
  props: ['portfolio', 'value', 'refresh'],
  name: 'ActionModalPortfolio',
  watch: {
    modalId: function () {
      this.init()
    }
  },
  methods: {
    createPortfolio: function (event) {
      event.preventDefault()

      this.submitPortfolio.loading = true

      let method = this.action === 'create' ? 'post' : 'patch'

      this.axios[method]('/portfolio/' + (this.portfolio !== null ? this.portfolio.id : ''), {
        name: this.name,
        description: this.description
      }).then((response) => {
        if (typeof this.refresh !== 'undefined') {
          this.refresh(response.data)
        }
        this.$emit('input', response.data)
        $('#' + this.modalId + '').modal('toggle')
        this.name = null
        this.description = null
        this.errorName = null
        this.errorDescription = null
      })
        .catch((error) => {
          if (error.response.status === 400) {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorName = errors['name'][0]
                break
              case 2:
                this.errorDescription = errors['description'][0]
                break
            }
          }
        })
        .finally(() => {
          this.submitPortfolio.loading = false
        })
    },
    deletePortfolio: function () {
      event.preventDefault()
      this.submitPortfolio.loading = true

      this.axios.delete('/portfolio/' + this.portfolio.id)
        .then((response) => {
          this.refresh(Date.now())
        })
        .finally(() => {
          $('#' + this.modalId + '').modal('toggle')
          this.submitPortfolio.loading = false
        })
    },
    init: function () {
      this.action = this.value

      switch (this.action) {
        case 'create' :
          this.modalId = 'createPortfolio'
          break
        case 'edit' :
          this.modalId = 'editPortfolio-' + this.portfolio.id
          break
        case 'delete' :
          this.modalId = 'deletePortfolio-' + this.portfolio.id
          break
      }

      if (this.portfolio !== null) {
        this.name = this.portfolio.name
        this.description = this.portfolio.description
      } else {
        this.name = null
        this.description = null
      }
    },
    onCancel: function () {
    },
    showModal: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('basic_project')
        return false
      }

      $('#' + this.modalId).modal()
      $('#' + this.modalId).on('hidden.bs.modal', (e) => {
        this.$emit('input', null)
      })
    }
  },
  data () {
    return {
      action: null,
      name: null,
      description: null,
      errorName: null,
      errorDescription: null,
      submitPortfolio: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      modalId: null
    }
  },
  mounted () {
    this.showModal()
  },
  beforeMount () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/ActionModalPortfolio.vue